import ExpandableImage from './ExpandableImage.vue';
import Vue from 'vue';
import { CarouselPlugin, IconsPlugin, ModalPlugin } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(CarouselPlugin);
Vue.use(IconsPlugin);
Vue.use(ModalPlugin);

export default (caroInstance) => {
  caroInstance.forEach((el) => {
    const props = JSON.parse(el.getAttribute('data'));
    const id = el.getAttribute('id');
    props.width = el.offsetWidth;
    if (!id) return;

    new Vue({
      render: (h) => h(ExpandableImage, { props }),
    }).$mount(`#${id}`);
  });
};
